export const v0Properties = [
  "orderNumber",

  // "productType",
  "deliveryType",
  "vehicleType",

  "date",
  "scheduledTime",

  "senderName",
  "senderAddress",
  "senderBuildingNumber",
  "senderPhone",
  "senderNote",

  "recipientName",
  "recipientAddress",
  "buildingNumber",
  "recipientPhone",
  "dropOffNote",

  "parcelValue",
  "parcelDimensions",

  "orderReferenceId",
]
